module.exports = __webpack_public_path__ + "img/ic_head_logout.f4adb234.svg";